import Fullpage from 'fullpage.js'
import imagesLoaded from 'imagesloaded'

const header = document.querySelector('.site-header')
export default {
  init() {
    const vid = document.getElementById('myVideo')
    const scrollIcon = document.querySelector('.welcome__scroll-icon')
    const fullpage = new Fullpage('.home-fullpage', {
      licenseKey: 'BD13C582-F31F4AE6-ABD78E7A-BAD33678',
      // responsiveWidth: 1092,
      // responsiveHeight: 500,
      responsiveSlides: true,
      navigation: true,
      navigationPosition: 'right',
      anchors: [
        'welcome',
        'service',
        'research',
        'development',
        'transformer',
        'success-award',
        'contact',
      ],
      navigationTooltips: [
        'Welcome',
        'Service',
        'Research',
        'Development',
        'Transformer',
        'Success Award',
        'Contact Us',
      ],
      onLeave(origin, destination) {
        if (origin.anchor !== 'success-award') {
          origin.item.classList.remove('loaded')
        }
        if (destination.anchor === 'welcome') {
          vid.play()
          header.classList.remove('is-sticky')
        } else {
          vid.pause()
          header.classList.add('is-sticky')
        }
      },
      afterLoad(origin, destination) {
        // if (destination.anchor === 'business-area') {
        // }
        destination.item.classList.add('loaded')
      },
    })

    scrollIcon.addEventListener('click', (e) => {
      console.log('asdasd')
    })

    imagesLoaded(document.querySelector('.welcome'), (instance) => {
      setTimeout(() => {
        document.querySelector('.welcome').classList.add('playing')
        setTimeout(() => {
          vid.play()
        }, 600)
      }, 2000)
    })
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
}
